import { formatDuration, shortDayReasons, type ClosedDayFigures } from "@/lib/work-hours";

/**
 * Hours for a closed day, and why it is short when it is (BR-155).
 *
 * The status chip alone said "Partial" and never why, which QA reasonably read
 * as the shortfall going unflagged. An open day shows a dash: its running total
 * is not a day's worth of anything yet.
 */
export function WorkedHours({
  record,
}: {
  record: ClosedDayFigures & { checkOutAt: string | null };
}) {
  if (!record.checkOutAt || record.durationMinutes == null) {
    return <span className="text-muted-foreground">—</span>;
  }
  const reasons = shortDayReasons(record);
  return (
    <div className="whitespace-nowrap">
      <div className="font-mono">{formatDuration(record.durationMinutes)}</div>
      {reasons.length > 0 && (
        <div className="text-[11px] text-warning">{reasons.join(" · ")}</div>
      )}
    </div>
  );
}
